import { useState, useEffect } from 'react';
import { useAuth } from "../Auth/AuthContext";
import QATicketApiService from '../../ApiServices/QATicketApiServices/QATicketApiService';
import { init } from 'aos';


const QATicketReplyModal = ({ isOpen, onClose, ticketId, initialMessages }) => {

    const [messages, setMessages] = useState(initialMessages ?? []);
    const [newMessage, setNewMessage] = useState('');   
    
    const { authState } = useAuth();
    const user = authState.user;
    useEffect(() => {
        setMessages(initialMessages);
      }, [initialMessages]);


    // Handle sending new message   
    const handleSendMessage = async () => {
        if (newMessage.trim() === '') return;

        const messageObj = {
            senderId: user.id, // Assuming Admin is sending
            text: newMessage,
            ticketId: ticketId,
            senderName : user.firstName
        };
        await QATicketApiService.AddReply(messageObj);
        setMessages([...messages, messageObj]);
        setNewMessage('');
    };

    if (!isOpen) return null;

    return (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex justify-center items-center z-50">
            <div className="bg-white w-96 rounded-lg shadow-lg p-4">
                <div className="flex justify-between items-center border-b pb-2">
                    <h2 className="text-lg font-semibold">QA Ticket Conversation</h2>
                    <button onClick={onClose} className="text-gray-500 hover:text-red-500">&times;</button>
                </div>

                {/* Messages */}
                <div className="h-64 overflow-y-auto mt-4 space-y-2">
                    {messages.length === 0 ? (
                        <p className="text-gray-500 text-center">No messages yet.</p>
                    ) : (
                        messages.map((msg, idx) => (
                            <div key={idx} className={`p-2 rounded-md ${user.id == msg.senderId ? 'bg-blue-100 self-end' : 'bg-gray-100'}`}>
                                <p className="text-sm font-semibold">{msg.senderName}</p>
                                <p>{msg.text}</p>
                                <p className="text-xs text-gray-500 text-right">{msg.createdAt}</p>
                            </div>
                        ))
                    )}
                </div>

                {/* New Message Input */}
                <div className="flex mt-4 space-x-2">
                    <input
                        type="text"
                        value={newMessage}
                        onChange={(e) => setNewMessage(e.target.value)}
                        placeholder="Type a message..."
                        className="flex-1 border rounded-md p-2 focus:outline-none focus:ring-2 focus:ring-blue-400"
                    />
                    <button
                        onClick={handleSendMessage}
                        className="bg-primaryColor text-white px-4 py-2 rounded-md hover:bg-blue-600"
                    >
                        Send
                    </button>
                </div>
            </div>
        </div>
    );
};

export default QATicketReplyModal;
